import { Injectable } from '@angular/core';
import { ProjectService, WmHttpService } from '@wms/app/services';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WidgetTemplatesService {

  listBackgroundPositions = {
    "action-list": {
      "backgroundPosition": "-46px -14285px"
    },
    "contact-list": {
      "backgroundPosition": "-46px -15066px"
    },
    "email-list": {
      "backgroundPosition": "-46px -14683px"
    },
    "media-list": {
      "backgroundPosition": "-46px -15443px"
    },
    "business-card": {
      "backgroundPosition": "-46px -7319px"
    },
    "contact-card": {
      "backgroundPosition": "-46px -7806px"
    },
    "designation-card": {
      "backgroundPosition": "-46px -8364px"
    },
    "i-card": {
      "backgroundPosition": "-46px -8984px"
    },
    "product-overview": {
      "backgroundPosition": "-46px -12337px"
    },
    "product-thumbnail": {
      "backgroundPosition": "-46px -12556px"
    },
    "product-inventory": {
      "backgroundPosition": "-46px -11717px"
    },
    "media-post": {
      "backgroundPosition": "-46px -9604px"
    },
    "news-post": {
      "backgroundPosition": "-46px -10477px"
    },
    "personal-spotlight": {
      "backgroundPosition": "-46px -11097px"
    }
  };

  defaultWizardStepProperties = {
    "wm-wizardstep": {
      "iconclass": "",
      "doneiconclass": ""
    }
  };

  defaultWizartdStepPropertiesForIcon = {
    "wm-wizardstep": [{
      "iconclass": "wi wi-person",
      "doneiconclass": "wi wi-done"
    },
    {
      "iconclass": "wi wi-description",
      "doneiconclass": "wi wi-done"
    },
    {
      "iconclass": "wi wi-account-balance",
      "doneiconclass": "wi wi-done"
    }]
  };

  layouts: any = {
    "wm-wizard": [
      {
        "id": "Number_Horizontal",
        "name": "Number Horizontal",
        "description": "Number Horizontal",
        "properties": {
          "class": "number"
        },
        "childNodeProperties": this.defaultWizardStepProperties,
        "category": "wm-wizard",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "Number_Vertical",
        "name": "Number Vertical",
        "description": "Number Vertical",
        "properties": {
          "class": "number vertical"
        },
        "childNodeProperties": this.defaultWizardStepProperties,
        "category": "wm-wizard",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "Iconstepper_Horizontal",
        "name": "Iconstepper Horizontal",
        "description": "Iconstepper Horizontal",
        "properties": {
          "class": "iconstepper",
        },
        "childNodeProperties": this.defaultWizartdStepPropertiesForIcon,
        "category": "wm-wizard",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "Iconstepper_Vertical",
        "name": "Iconstepper Vertical",
        "description": "Iconstepper Vertical",
        "properties": {
          "class": "iconstepper vertical"
        },
        "childNodeProperties": this.defaultWizartdStepPropertiesForIcon,
        "category": "wm-wizard",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "Iconstepper_Textinline_Horizontal",
        "name": "Iconstepper Textinline Horizontal",
        "description": "Iconstepper Textinline Horizontal",
        "properties": {
          "class": "iconstepper text-inline"
        },
        "childNodeProperties": this.defaultWizartdStepPropertiesForIcon,
        "category": "wm-wizard",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "Iconstepper_Textinline_Vertical",
        "name": "Iconstepper Textinline Vertical",
        "description": "Iconstepper Textinline Vertical",
        "properties": {
          "class": "iconstepper text-inline vertical"
        },
        "childNodeProperties": this.defaultWizartdStepPropertiesForIcon,
        "category": "wm-wizard",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "Dottedstepper_Horizontal",
        "name": "Dottedstepper Horizontal",
        "description": "Dottedstepper Horizontal",
        "properties": {
          "class": "dottedstepper"
        },
        "childNodeProperties": this.defaultWizardStepProperties,
        "category": "wm-wizard",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "Dottedstepper_Vertical",
        "name": "Dottedstepper Vertical",
        "description": "Dottedstepper Vertical",
        "properties": {
          "class": "dottedstepper vertical"
        },
        "childNodeProperties": this.defaultWizardStepProperties,
        "category": "wm-wizard",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "Dottedstepper_Textinline_Horizontal",
        "name": "Dottedstepper Textinline Horizontal",
        "description": "Dottedstepper Textinline Horizontal",
        "properties": {
          "class": "dottedstepper text-inline"
        },
        "childNodeProperties": this.defaultWizardStepProperties,
        "category": "wm-wizard",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "Dottedstepper_Textinline_Vertical",
        "name": "Dottedstepper Textinline Vertical",
        "description": "Dottedstepper Textinline Vertical",
        "properties": {
          "class": "dottedstepper text-inline vertical"
        },
        "childNodeProperties": this.defaultWizardStepProperties,
        "category": "wm-wizard",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "Classic",
        "name": "Classic",
        "description": "Classic",
        "properties": {
          "class": "classic"
        },
        "childNodeProperties": this.defaultWizardStepProperties,
        "category": "wm-wizard",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }
    ],
    "wm-tree":[
      {
        "id": "Classic",
        "name": "Classic",
        "description": "Classic",
        "properties": {
          "class": "Classic"
        },
        "category": "wm-tree",
        "thumbnail": "thumbnail.svg",
        "screenshots": []
      },
      {
        "id": "CheckBox",
        "name": "CheckBox",
        "description": "CheckBox",
        "properties": {
          "class": "Checkbox"
        },
        "category": "wm-tree",
        "thumbnail": "thumbnail.svg",
        "screenshots": []
      },
      {
        "id": "Radio",
        "name": "Radio",
        "description": "Radio",
        "properties": {
          "class": "Radio"
        },
        "category": "wm-tree",
        "thumbnail": "thumbnail.svg",
        "screenshots": []
      }
    ],
    "wm-breadcrumb": [
      {
        "id": "Path_Based",
        "name": "Arrow",
        "description": "Path-Based",
        "properties": {
          "class": "path-based"
        },
        "category": "wm-breadcrumb",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "Classic",
        "name": "Classic 1",
        "description": "Classic",
        "properties": {
          "class": "classic"
        },
        "category": "wm-breadcrumb",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "Attribute_Based",
        "name": "Classic 2",
        "description": "Attribute-Based",
        "properties": {
          "class": "attribute-based"
        },
        "category": "wm-breadcrumb",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }
    ],
    "wm-container": [

      {
        "id": "default_container",
        "name": "Default Container",
        "description": "Container with default parameters",
        "category": "wm-container",
        "thumbnail": "thumbnail.png",
        "properties": {
          "class": ""
        },
        "screenshots": []
      },
      {
        "id": "elevated_container",
        "name": "Elevated Container",
        "description": "Container appears to be elevated from surface.",
        "properties": {
          "class": "app-elevated-container"
        },
        "category": "wm-container",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      },
      {
        "id": "outlined_container",
        "name": "Outlined Container",
        "description": "Container with just border",
        "properties": {
          "class": "app-outlined-container"
        },
        "category": "wm-container",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }
    ],
    "wm-label": [
      {
        "id": "text-default",
        "name": "Default Text",
        "description": "Default Text",
        "properties": {
          "class": "p",
          "type": "p"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "h1",
        "name": "H1",
        "description": "Heading 1",
        "properties": {
          "class": "h1",
          "type": "h1"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "h2",
        "name": "H2",
        "description": "Heading 2",
        "properties": {
          "class": "h2",
          "type": "h2"

        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "h3",
        "name": "H3",
        "description": "Heading 3",
        "properties": {
          "class": "h3",
          "type": "h3"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "h4",
        "name": "H4",
        "description": "Heading 4",
        "properties": {
          "class": "h4",
          "type": "h4"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "h5",
        "name": "H5",
        "description": "Heading 5",
        "properties": {
          "class": "h5",
          "type": "h5"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "h6",
        "name": "H6",
        "description": "Heading 6",
        "properties": {
          "class": "h6",
          "type": "h6"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "text-primary",
        "name": "Primary Text",
        "description": "Primary Text",
        "properties": {
          "class": "text-primary",
          "type": "p"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "text-secondary",
        "name": "Secondary Text",
        "description": "Secondary Text",
        "properties": {
          "class": "text-secondary",
          "type": "p"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "text-success",
        "name": "Success Text",
        "description": "Success Text",
        "properties": {
          "class": "text-success",
          "type": "p"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "text-danger",
        "name": "Danger Text",
        "description": "Danger Text",
        "properties": {
          "class": "text-danger",
          "type": "p"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "text-warning",
        "name": "Warning Text",
        "description": "Warning Text",
        "properties": {
          "class": "text-warning",
          "type": "p"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "text-info",
        "name": "info Text",
        "description": "Info Text",
        "properties": {
          "class": "text-info",
          "type": "p"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "text-muted",
        "name": "Muted Text",
        "description": "Muted Text",
        "properties": {
          "class": "text-muted",
          "type": "p"
        },
        "category": "wm-label",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }
    ],
    "wm-button": [
      {
        "id": "btn-default",
        "name": "Default Button",
        "description": "Default Button",
        "properties": {
          "class": "btn-default"
        },
        "category": "wm-button",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "btn-primary",
        "name": "Primary Button",
        "description": "Primary Button",
        "properties": {
          "class": "btn-primary"
        },
        "category": "wm-button",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "btn-secondary",
        "name": "Secondary Button",
        "description": "Secondary Button",
        "properties": {
          "class": "btn-secondary"
        },
        "category": "wm-button",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "btn-success",
        "name": "Success Button",
        "description": "Success Button",
        "properties": {
          "class": "btn-success"
        },
        "category": "wm-button",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "btn-danger",
        "name": "Danger Button",
        "description": "Danger Button",
        "properties": {
          "class": "btn-danger"
        },
        "category": "wm-button",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "btn-warning",
        "name": "Warning Button",
        "description": "Warning Button",
        "properties": {
          "class": "btn-warning"
        },
        "category": "wm-button",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "btn-info",
        "name": "Info Button",
        "description": "Info Button",
        "properties": {
          "class": "btn-info"
        },
        "category": "wm-button",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }, {
        "id": "btn-link",
        "name": "Link Button",
        "description": "Link Button",
        "properties": {
          "class": "btn-link"
        },
        "category": "wm-button",
        "thumbnail": "thumbnail.png",
        "screenshots": []
      }
    ]
  }

  private API_META: any = {
    getTemplateMarkup: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/templatebundles/:templateBundleId/versions/:versionId/files/widgetTemplates/:templateId/:templateId.html",
      method: "GET"
    }
  }
  private TARGET: string = 'WidgetTemplates';


  constructor(private wmHttpService: WmHttpService, private projectService: ProjectService) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
  }

  /**
   * @ngdoc function
   * @name wmCore.$WidgetTemplatesService#getMarkup
   * @methodOf wmCore.$WidgetTemplatesService
   * @function
   *
   * @description
   * retrieves the template markup
   *
   * @param {string} templateBundleId id of template bundle
   * @param {string} templateId id of the template
   */
  getMarkup(templateBundleId: any, templateId: any, versionId: any) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getTemplateMarkup',
      pathParams: {
        projectID: this.projectService.getProjectId(),
        templateBundleId: templateBundleId,
        templateId: templateId,
        versionId: versionId
      },
      responseType: "text"
    }) as Promise<any>);
  }

  /**
   * @ngdoc function
   * @name wmCore.$WidgetTemplatesServicee#getLayouts
   * @methodOf wmCore.$WidgetTemplatesService
   * @function
   *
   * @description
   * retrieves the list of layouts
   *
   * @param {string} category widget type of the template
   */
  getLayouts(category: any) {
    return this.layouts[category];
  }

  /**
   * @ngdoc function
   * @name wmCore.$WidgetTemplatesServicee#getBackgroundPositions
   * @methodOf wmCore.$WidgetTemplatesService
   * @function
   *
   * @description
   * retrieves the listBackgroundPositions
   *
   */
  getBackgroundPositions() {
    return this.listBackgroundPositions;
  }

}
